<div class="fx-bonus-history card bg-dark-lighter text-white">
  <div class="card-header ">
    {{ 'Bonus Manual Control' | uppercase }}
  </div>
  <div class="card-body" id="manual_transaction">
    <div class="p-15">
      <div class="row mb-15">
        <div class="col-md-6 col-xs-12">
          <div
            class="input-group search-group" [ngClass]="{ loading: loading }">
            <input
              type="text"
              class="form-control bg-dark"
              name="keyword"
              [(ngModel)]="condition.keyword"
              placeholder="Search email"/>
            <div class="input-group-append">
              <button
                class="btn btn-main"
                type="button"
                (click)="searchHistory(true)"
              >
                Search
              </button>
              <button
                class="btn btn-main ml-2"
                type="button"
                (click)="onRefresh(true)"
              >
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <div class="table-responsive">
            <form class="form" name="form">
              <table class="rox-table table-bordered bg-dark">
                <thead>
                <tr>
                  <th class="text-center">ID</th>
                  <th class="text-center">User Name</th>
                  <th class="text-center">Email</th>
                  <th class="text-center" create-permission></th>
                </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                        let item of data
                          | paginate
                            : {
                                id: 'bonus_manual_history',
                                itemsPerPage: pageInfo.pageSize,
                                currentPage: pageInfo.pageIndex,
                                totalItems: pageInfo.totalRecord
                              };
                        let i = index
                      "
                  >
                    <td class="text-center">{{item.id}}</td>
                    <td class="text-center">{{item.getUsername()}}</td>
                    <td class="text-center">{{ item.email}}</td>
                    <td class="text-center action-change-amount" create-permission>
                      <a
                        href="javascript:void(0)"
                        class="text-blue-lighter"
                        (click)="getBonusInfo(item)"
                        data-bs-toggle="modal"
                        data-bs-target="#modalBonusChangeAmount"
                      >View</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>
          </div>
        </div>
      </div>
      <div class="row mt-15">
        <div class="col">
          <div class="pagination-wrapper">
            <pagination-controls
              id="bonus_manual_history"
              (pageChange)="pageChanged($event)"
              autoHide="true"
              responsive="true"
              previousLabel="Prev"
              nextLabel="Next"
            >
            </pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- CHANGE AMOUNT MODAL -->
  <div class="modal fade fx-modal" id="modalBonusChangeAmount" #modalUser>
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h2 class="modal-title font-bold" style="margin-bottom: 0">{{ itemBonus.name }}</h2>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body ">
          <table class="rox-table table-bordered bg-dark" *ngIf="itemBonus.data">
            <thead>
            <tr>
              <th class="text-center">No</th>
              <th class="text-center">MT5 Account</th>
              <th class="text-center">Account Type</th>
              <th class="text-center">Balance</th>
              <th class="text-center">Credit</th>
              <th class="text-center">Currency</th>
              <th class="text-center">Amount</th>
              <th class="text-center"></th>
              <th class="text-center"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of itemBonus.data; let i = index">
              <td class="text-center">{{ i }}</td>
              <td class="text-center">{{ item.login }}</td>
              <td class="text-center">{{ item.accountType }}</td>
              <td class="text-center"><span
                labelNumber="{{ item.balance }}"
                [currency]="item.currency"
                [emo]="'1'"
              ></span></td>
              <td class="text-center">
                <span labelNumber="{{item.credit}}" [currency]="item.currency"></span>
              </td>
              <td class="text-center">{{ item.currency | uppercase}}</td>
              <td class="text-center">
                <input type="number" [(ngModel)]="item.amount "
                       class="{{(submited && currentIndex == item.login && item.amount <= 0) ? 'invalid' : ''}}">
              </td>
              <td class="text-center action-change-amount">
                <button class="btn btn-mainuce" (click)="onChangeAmount('reduce', item)">-</button>
                <button class="btn btn-add" (click)="onChangeAmount('add', item)">+</button>
              </td>
              <td class="text-center">
                <a
                  href="javascript:void(0)"
                  class="text-blue-lighter"
                  (click)="getHisMT4Info(item)"
                  data-bs-toggle="modal"
                  data-bs-target="#modalHistoryAccountMT"
                >View</a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- CHANGE HIS ACCOUNT MODAL -->
  <div class="modal fade fx-modal modal-history-account" id="modalHistoryAccountMT" #modalUser>
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h2 class="modal-title font-bold" style="margin-bottom: 0; text-transform: uppercase">
            {{'MT5 - ' + historyMT4Info.login + '  (' + historyMT4Info.currency + ')' }}
          </h2>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body ">
          <table class="rox-table table-bordered bg-dark" *ngIf="historyMT4Info.data">
            <thead>
            <tr>
              <th class="text-center">No</th>
              <th class="text-center">Date</th>
              <th class="text-center">Amount</th>
              <th class="text-center">PIC</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let his of historyMT4Info.data; let i = index">
              <td class="text-center">{{i}}</td>
              <td class="text-center">{{his.create_time | date: 'yyyy/MM/dd'}}</td>
              <td class="text-center">
                <span labelNumber="{{his.volume}}" [currency]="historyMT4Info.currency"></span>
              </td>
              <td class="text-center">{{his.username}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
